var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCalendar = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  className: "a",
  opacity: 0.48
}, /*#__PURE__*/React.createElement("rect", {
  className: "b",
  width: 24,
  height: 24,
  opacity: 0
}), /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M41.091,344H41a1,1,0,0,0-2,0H37a1,1,0,0,0-2,0H33a1,1,0,0,0-2,0h-.091A2.9,2.9,0,0,0,28,346.95v9.1A2.9,2.9,0,0,0,30.909,359H41.091A2.9,2.9,0,0,0,44,356.05v-9.1A2.9,2.9,0,0,0,41.091,344ZM42,356.05a.9.9,0,0,1-.909.95H30.909a.9.9,0,0,1-.909-.95V356h2a1,1,0,0,0,0-2H30v-1h2a1,1,0,0,0,0-2H30v-1h9a1,1,0,0,0,0-2H30v-1.05a.9.9,0,0,1,.909-.95H31a1,1,0,0,0,2,0h2a1,1,0,0,0,2,0h2a1,1,0,0,0,2,0h.091a.9.9,0,0,1,.909.95V351H40a1,1,0,0,0,0,2h2v1H40a1,1,0,0,0,0,2h2ZM38,352a1,1,0,0,1-1,1H35a1,1,0,0,1,0-2h2A1,1,0,0,1,38,352Zm0,3a1,1,0,0,1-1,1H35a1,1,0,0,1,0-2h2A1,1,0,0,1,38,355Z",
  transform: "translate(-24 -339)"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/calendar.3d1c28dc.svg";
export { ForwardRef as ReactComponent };